import { jsx as _jsx } from "react/jsx-runtime";
import { errorId } from '@rjsf/utils';
import { FormErrorMessage, List, ListItem } from '@chakra-ui/react';
/** The `FieldErrorTemplate` component renders the errors local to the particular field
 *
 * @param props - The `FieldErrorProps` for the errors being rendered
 */
export default function FieldErrorTemplate(props) {
    const { errors = [], idSchema } = props;
    if (errors.length === 0) {
        return null;
    }
    const id = errorId(idSchema);
    return (_jsx(List, { children: errors.map((error, i) => {
            return (_jsx(ListItem, { children: _jsx(FormErrorMessage, { id: id, children: error }) }, i));
        }) }));
}
//# sourceMappingURL=FieldErrorTemplate.js.map